import React from 'react';

type HttpAuthContextValue = {
  isReady: boolean;
};

export const HttpAuthContext = React.createContext<HttpAuthContextValue>({
  isReady: false,
});

export const useHttpAuthReady = () => React.useContext(HttpAuthContext).isReady;
